let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5uZkX")).then(() => parcelRequire('f6PNw'));